import { formatDate } from '../../utils';
import type { FupLink } from '../../types/orchestrator';

export type FupLinkVisualStatus = 'success' | 'waiting' | 'expired';

const BRAZIL_TIME_ZONE = 'America/Sao_Paulo';

function toBrazilDateFromTimestamp(value: string): string | null {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    const dateOnly = value.trim().slice(0, 10);
    return /^\d{4}-\d{2}-\d{2}$/.test(dateOnly) ? dateOnly : null;
  }

  return new Intl.DateTimeFormat('en-CA', {
    timeZone: BRAZIL_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(parsed);
}

function getTodayDateOnly(): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: BRAZIL_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}

export function resolveFupLinkVisualStatus(
  link: FupLink,
  today: string = getTodayDateOnly(),
): FupLinkVisualStatus {
  if (link.responded_at) {
    return 'success';
  }

  const createdOn = toBrazilDateFromTimestamp(link.created_at);
  if (createdOn !== null && createdOn < today) {
    return 'expired';
  }

  return 'waiting';
}

const FUP_LINK_STATUS_LABELS: Record<FupLinkVisualStatus, string> = {
  success: 'FUP respondido',
  waiting: 'Aguardando resposta da aluna',
  expired: 'Tentativa expirou sem resposta',
};

export function getFupLinkStatusLabel(status: FupLinkVisualStatus): string {
  return FUP_LINK_STATUS_LABELS[status];
}

export function formatFupLinkCreatedDate(createdAt: string): string {
  return formatDate(createdAt);
}

export function canRemoveFupLink(
  link: FupLink,
  today: string = getTodayDateOnly(),
): boolean {
  return resolveFupLinkVisualStatus(link, today) === 'waiting';
}

export function sortFupLinksForDisplay(links: FupLink[]): FupLink[] {
  return [...links].sort((left, right) => left.attempt_number - right.attempt_number);
}

export function hasUnrespondedFupLink(links: readonly FupLink[]): boolean {
  return links.some((link) => !link.responded_at);
}

export function hasRespondedFupLink(links: readonly FupLink[]): boolean {
  return links.some((link) => Boolean(link.responded_at));
}
